var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileCheckIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6663 10.9167V6.16675C16.6663 4.76662 16.6663 4.06655 16.3939 3.53177C16.1542 3.06137 15.7717 2.67892 15.3013 2.43923C14.7665 2.16675 14.0665 2.16675 12.6663 2.16675H7.33301C5.93288 2.16675 5.23281 2.16675 4.69803 2.43923C4.22763 2.67892 3.84517 3.06137 3.60549 3.53177C3.33301 4.06655 3.33301 4.76662 3.33301 6.16675V14.8334C3.33301 16.2335 3.33301 16.9336 3.60549 17.4684C3.84517 17.9388 4.22763 18.3212 4.69803 18.5609C5.23281 18.8334 5.93288 18.8334 7.33301 18.8334H9.99967M11.6663 9.66675H6.66634M8.33301 13.0001H6.66634M13.333 6.33341H6.66634M12.083 16.3334L13.7497 18.0001L17.4997 14.2501",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCheckIcon);
export default __webpack_public_path__ + "static/media/fileCheckIcon.ce071bc9eb7d6e8ce6506074c6da6915.svg";
export { ForwardRef as ReactComponent };